'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElementWithClassName = cloneElementWithClassName;
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.isMuiComponent = isMuiComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/prefer-default-export */

function cloneElementWithClassName(child, className) {
  return _react2.default.cloneElement(child, {
    className: (0, _classnames2.default)(child.props.className, className)
  });
}

function cloneChildrenWithClassName(children, className) {
  return _react2.default.Children.map(children, function (child) {
    return _react2.default.isValidElement(child) && cloneElementWithClassName(child, className);
  });
}

function isMuiElement(element, muiNames) {
  return _react2.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function isMuiComponent(element, muiNames) {
  return muiNames.indexOf(element.muiName) !== -1;
}


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/utils/reactHelpers.js
// module id = 189
// module chunks = 0